export default {
  hero: {
    title: "Basetao Spreadsheet — O guia completo de produtos, vendedores e recursos",
    subtitle:
      "Encontre, compare e entenda os recursos do Basetao Spreadsheet em um só lugar. Explore guias práticos, informações de vendedores, pesquisa de produtos, custos de envio, detalhes do armazém, cupons, avaliações, dicas de QC e orientações de segurança.",
    trust: "Recurso independente · Guias práticos · Atualizado regularmente",
    dropdownLabel: "Explorar uma categoria",
    dropdownPlaceholder: "Escolha uma categoria…",
  },
  whatIs: {
    title: "O que é Basetao Spreadsheet?",
    p1: "Um Basetao Spreadsheet é um banco de dados de produtos organizado que ajuda os compradores a encontrar e comparar itens disponíveis por meio do agente de compras Basetao. Em vez de rolar por milhares de anúncios individuais, você pode navegar por um único documento estruturado que agrupa os produtos por categoria e inclui detalhes úteis, como informações do vendedor, referências de produtos e notas práticas.",
    p2: "Pense nele como um mapa: ele não vende nada por si só, mas ajuda você a entender quais produtos existem, como estão agrupados e onde procurar em seguida. O spreadsheet é organizado em torno de categorias de compra comuns — calçados, moletons, camisetas, jaquetas, bolsas, cintos e mais — para que você possa restringir rapidamente sua pesquisa ao tipo de produto que realmente deseja.",
  },
  article: {
    title: "Guias e recursos",
    subtitle: "Leia guias claros e originais para aproveitar ao máximo o Basetao Spreadsheet.",
    cardTitle: "O que é Basetao Spreadsheet? Guia para iniciantes",
    cardDesc:
      "Uma visão geral completa e amigável: o que é o spreadsheet, o que ele contém, como usá-lo e o que verificar antes de fazer um pedido.",
    readMore: "Ler o guia",
    viewAll: "Ver todos os guias",
    related: "Artigos relacionados",
    updated: "Atualizado regularmente",
  },
  faq: {
    title: "Perguntas frequentes",
    q1: "O que é Basetao Spreadsheet?",
    a1: "É uma lista organizada por categorias de produtos e referências que ajuda os compradores a pesquisar itens disponíveis por meio do agente de compras Basetao.",
    q2: "Como uso o Basetao Spreadsheet?",
    a2: "Abra o spreadsheet, escolha uma categoria, anote as referências de produtos que você quer, compare os detalhes dos vendedores e verifique os preços e a disponibilidade atuais na plataforma oficial antes de fazer o pedido.",
    q3: "A Basetao é legítima?",
    a3: "A Basetao é um agente de compras conhecido, mas, como com qualquer agente, você deve sempre verificar vendedores, produtos, preços e políticas por conta própria antes de tomar uma decisão de compra.",
    q4: "Quanto custa o envio da Basetao?",
    a4: "Os custos de envio dependem do peso, volume, destino e método de envio que você escolher. As taxas mudam com o tempo, então verifique sempre as condições atuais antes de pedir.",
    q5: "A Basetao tem cupons ou códigos de desconto?",
    a5: "Ofertas podem aparecer de tempos em tempos, mas a disponibilidade e a elegibilidade podem mudar. Verifique sempre se um código ainda é válido antes de depender dele.",
  },
  ctaSection: {
    title: "Pronto para explorar o spreadsheet completo?",
    subtitle:
      "Navegue pelo catálogo completo, compare categorias e comece a pesquisar produtos no site principal.",
    button: "Visitar o site principal",
  },
};